import _ from 'lodash';
import {IIndicatorData, SurveySlug} from './types';

export const buildApiKey = (slug: SurveySlug): string => {
    let key = slug.numerator.question;

    if (slug.denominator) {
        key += `_${slug.denominator.question}`;
    }

    if (slug.numerator.value) {
        key += `_${_.kebabCase(slug.numerator.value.toString())}`;
    }

    return key;
};

export const serializeSlug = (s: SurveySlug) => ({
    numerator: s.numerator,
    ...(s.denominator && {denominator: s.denominator}),
    ...(s.operation && {operation: s.operation}),
    ...(s.perUoa && {per_uoa: 1}),
    ...(s.perUoaLatest && {per_uoa_latest: 1}),
    ...((s.perParentUoa || s.aggregateChildren) && {per_parent_uoa: 1}),
    ...(s.aggregateChildren && {self_is_parent: 1}),
    ...(s.positiveRatio && {positive_ratio: 1}),
    ...(s.fallbacks?.length && {
        fallbacks: s.fallbacks.map((f) => ({
            ...(f.operation && {operation: f.operation}),
            numerator: f.numerator,
            ...(f.denominator && {denominator: f.denominator}),
        })),
    }),
});

export const scaleToPercentage = ({uoa, average, group}: IIndicatorData): IIndicatorData => ({
    uoa: uoa !== null ? uoa * 100 : null,
    average: average !== null ? average * 100 : null,
    group: group != null ? group * 100 : group,
});
